import { render, staticRenderFns } from "./BatchTransaction.vue?vue&type=template&id=403344fc&"
import script from "./BatchTransaction.vue?vue&type=script&lang=js&"
export * from "./BatchTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports